<script>
import { everything } from '@sejazipper/layer-api-client';
// eslint-disable-next-line import/no-unresolved
import moment from 'moment';
import DashboardHeader from '../components/DashboardGestor/DashboardHeader.vue';
import DashboardStatistics from '../components/DashboardGestor/DashboardStatistics.vue';
import DashboardCampaigns from '../components/DashboardGestor/DashboardCampaigns.vue';
import DashboardShopsStats from '../components/DashboardGestor/DashboardShopsStats.vue';
import DashboardCampaignResultDialog from '../components/DashboardGestor/DashboardCampaignResultDialog.vue';

import Loader from '../components/Loader.vue';
import { useCampaignsResults } from '../composables/useCampaignsResults';
import { useZipperApi } from '../composables/useZipperApi';

const { client } = useZipperApi();

export default {
  components: {
    DashboardHeader,
    DashboardStatistics,
    DashboardCampaigns,
    DashboardShopsStats,
    DashboardCampaignResultDialog,
    Loader,
  },

  data: () => ({
    showDialog: false,
  }),

  computed: {
    profile() {
      return this.$store.getters.getProfile;
    },
    customer() {
      return this.$store.getters.getCustomer;
    },
  },

  async mounted() {
    this.loadingResults = useCampaignsResults().loadingResults;

    // await this.validateIfTheDialogWasSeen();
  },

  methods: {
    // async validateIfTheDialogWasSeen() {
    //   const seller = await client.chain.query
    //     .findSellerById({
    //       id: this.profile.id,
    //     })
    //     .get({
    //       ...everything,
    //     });

    //   if (!seller.seenDialog) {
    //     this.showDialog = true;
    //     seller.seenDialog = true;
    //     seller.seenDialogDate = moment();

    //     delete seller.__typename;

    //     await client.chain.mutation
    //       .updateFieldsSeller({
    //         customerId: this.customer.id,
    //         seller,
    //       })
    //       .get({ ...everything });
    //   }

    //   const now = moment();

    //   const dateDiff = now.diff(seller.seenDialogDate, 'days');

    //   if (seller.seenDialog && dateDiff < 7) {
    //     const lastViewDate = localStorage.getItem('dialogLastViewDate');

    //     if (!lastViewDate || now.diff(lastViewDate, 'days') > 1) {
    //       this.showDialog = true;
    //       localStorage.setItem('dialogLastViewDate', now);
    //     }
    //   }
    // },

    closeDialog() {
      this.showDialog = false;
    },
  },
};
</script>

<template>
  <v-container
    class="dashboard mt-3 px-4"
    style="min-height: 100vh"
  >
    <div v-if="profile && profile.name && !loadingResults">
      <DashboardHeader />
      <DashboardStatistics v-if="!customer.onlyCatalogue" />
      <DashboardCampaigns v-if="!customer.onlyCatalogue" />
      <DashboardShopsStats v-if="$store.getters.containsCatalogue" />
      <DashboardCampaignResultDialog />
    </div>

    <div
      v-else
      class="ma-2"
    >
      <Loader />
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
.dashboard {
  margin-bottom: 60pt;
}

</style>
